import { Avatar, Card, CardContent, CardHeader, Divider, Grid, IconButton, Tooltip, Typography, } from "@material-ui/core";
import { Link } from "@material-ui/icons";
import React from "react";
import { userRendererStyles } from "./useRendererStyles";
export const CountTile = ({ tile, navigate }) => {
    const classes = userRendererStyles();
    const getColorClass = (lowerLimit, upperLimit, value) => {
        if (value <= lowerLimit) {
            return classes.green;
        }
        if (value > lowerLimit && value < upperLimit) {
            return classes.amber;
        }
        if (value >= upperLimit) {
            return classes.red;
        }
    };
    return (React.createElement(Grid, { item: true, xs: 12, xl: 2, lg: 3, md: 4 },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, { action: React.createElement(Tooltip, { title: `View list of ${tile.title}` },
                    React.createElement(IconButton, { onClick: () => navigate && navigate(tile.filterUrl) },
                        React.createElement(Link, null))), title: React.createElement(Typography, { variant: "body1", className: classes.cardHeading }, tile.title), className: classes.header }),
            React.createElement(Divider, null),
            React.createElement(CardContent, { className: classes.cardContent },
                React.createElement(Grid, { container: true }, tile.parsedData.map((data, index) => {
                    return (React.createElement(Grid, { item: true, xs: 4, key: index },
                        React.createElement("div", { className: classes.container },
                            React.createElement(Tooltip, { title: `View list ${data.title}` },
                                React.createElement(IconButton, { onClick: () => navigate && navigate(`${tile.filterUrl}&DashboardParam=${data.key}`) },
                                    React.createElement(Avatar, { className: `${classes.countAvatar} ${getColorClass(tile.lowerLimit || 0, tile.upperLimit || 10, data.value)}` }, data.value)))),
                        React.createElement("div", { className: classes.container },
                            React.createElement(Typography, { variant: "body2", className: classes.countCaption }, data.title))));
                }))))));
};
